module.exports = __webpack_public_path__ + "static/media/image2.e9da9226.png";